import { cn } from '@/lib/utils';
import { useApiHealth } from '@/hooks/use-api-health';

const STATES = {
  checking: { dot: 'bg-amber-400', label: 'Verificando conexión…', tone: 'text-ink-400' },
  online: { dot: 'bg-emerald-500', label: 'Servidor disponible', tone: 'text-ink-500' },
  offline: { dot: 'bg-rose-500', label: 'Sin conexión con el servidor', tone: 'text-rose-600' },
} as const;

/**
 * Indicador del estado de EDSuite API.
 *
 * Ayuda a distinguir un problema de credenciales de un backend caído. No muestra
 * la dirección del servidor (ni IP ni puerto): la pantalla de acceso es pública y
 * el dato no aporta nada al usuario.
 */
export function ApiStatus() {
  const health = useApiHealth();
  const state = STATES[health];

  return (
    <p className={cn('flex items-center justify-center gap-2 text-xs font-medium', state.tone)}>
      <span aria-hidden="true" className={cn('size-1.5 rounded-full', state.dot)} />
      {state.label}
    </p>
  );
}
